module.exports = __webpack_public_path__ + "img/開幕.b5f5c5ba.jpg";